import { approveToken, getTokenAllowance } from ".";
import {
  field,
  formatUnits,
  parseEther,
  readContract,
  writeContractAndWait,
  zeroAddress,
} from "../viem";
import MafiaRebirthAbi from "../../abis/MafiaRebirth.json";
import config from "../../config/config";
import { WalletErrorMsg } from "../../constants/const";
import { delay } from "../../utils/utils";

const address = config.mafiaRebirthAddress;
const abi = MafiaRebirthAbi;

export const quoteRebirth = async (
  user: string,
  optionId: number,
  swapTokenId: number,
  tokenDecimals: number
) => {
  const result: any = await readContract({
    address,
    abi,
    functionName: "quoteRebirth",
    args: [user, optionId, swapTokenId],
  });

  return {
    usdCost: Number(formatUnits(field(result, "usdCost", 0), 18)),
    inputToken: String(field(result, "inputToken", 1)),
    inputAmount: Number(
      formatUnits(field(result, "inputAmount", 2), tokenDecimals)
    ),
  };
};

export const getRebirthOption = async (optionId: number) => {
  const result: any = await readContract({
    address,
    abi,
    functionName: "getRebirthOption",
    args: [optionId],
  });

  return {
    costRatioBps: Number(field(result, "costRatioBps", 0)),
    enabled: Boolean(field(result, "enabled", 2)),
  };
};

export const initiateRebirth = async (
  optionId: number,
  swapTokenId: number,
  tokenAddress: string,
  tokenAmount: number,
  account: string
) => {
  if (tokenAddress.toLowerCase() === zeroAddress) {
    return writeContractAndWait({
      address,
      abi,
      functionName: "initiateRebirth",
      args: [optionId, swapTokenId],
      account,
      value: parseEther(tokenAmount.toFixed(18)),
    });
  }

  const tokenAllowance = await getTokenAllowance(tokenAddress, account, address);

  try {
    if (Number(tokenAllowance) < tokenAmount) {
      await approveToken(tokenAddress, tokenAmount, address, account);
      await delay(config.blockTime);
    }
  } catch (error: any) {
    if (error.message === WalletErrorMsg.Indexing) {
      await delay(config.blockTime);
    } else {
      throw error;
    }
  }

  return writeContractAndWait({
    address,
    abi,
    functionName: "initiateRebirth",
    args: [optionId, swapTokenId],
    account,
  });
};
